import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { LinkedInProfile } from "common/types";

import useBlacklistMutations from "../../../../../campaigns/datahooks/useBlacklistMutations";
import { startListLeadsBulkAction } from "../../../../utils";

interface UnblacklistLeadsProps {
  selectedLeads: LinkedInProfile[];
  onBack?: () => void;
  onClose: (shouldClearSelection: boolean) => void;
}

export default function UnblacklistLeads({
  selectedLeads,
  onBack,
  onClose,
}: UnblacklistLeadsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  //the blacklist is workspace-wide, so this doesn't touch the list itself
  const { removeFromBlacklist } = useBlacklistMutations();

  function unblacklistLeads() {
    startListLeadsBulkAction(
      ({ urn }, abortSignal) =>
        removeFromBlacklist({ accountUrn: urn, abortSignal }),
      selectedLeads,
      (finishedItemsCount) =>
        finishedItemsCount === selectedLeads.length
          ? "Leads unblacklisted"
          : `Unblacklisting ${finishedItemsCount}/${selectedLeads.length} leads`,
    );
    onClose(true);
  }

  return (
    <>
      <Header
        title="Remove from blacklist?"
        subtitle="They'll no longer be blocked across your workspace. To target them with this list again, restore them from the excluded tab"
        onBack={onBack}
      />

      <Footer className="justify-end">
        <Button variant="secondary-black" onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          variant="default-black"
          disabled={!selectedLeads.length}
          onClick={unblacklistLeads}
        >
          Unblacklist
        </Button>
      </Footer>
    </>
  );
}
